import * as React from 'react'

export function useOnResize (callback: () => void, dependencies: any[]) {
  React.useEffect(() => {
    window.addEventListener('resize', callback)
    return () => window.removeEventListener('resize', callback)
  }, dependencies) // eslint-disable-line react-hooks/exhaustive-deps
}
